import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import OutlinedInput from '@mui/material/OutlinedInput';
import InputAdornment from '@mui/material/InputAdornment';
import FormControl from '@mui/material/FormControl';
import PersonIcon from '@mui/icons-material/Person';
import LockIcon from '@mui/icons-material/Lock';
import Button from '@mui/material/Button';
import { login } from '../../redux/Actions/login.action';
import useStyles from './styles';

export default function Login(props) {
    const dispatch = useDispatch();
    const css = useStyles();

    const loginData = useSelector((state) => state.loginReducer);
    const [loginInfo, setLoginInfo] = useState({
        email: '',
        password: ''
    });

    const handleChange = (val) => (e) => {
        setLoginInfo({
            ...loginInfo,
            [val]: e.target.value
        });
    };

    const handleLogin = (e) => {
        e.preventDefault();
        dispatch(login(loginInfo, props.history));
    };

    const checkEnterPressed = (e) => {
        if (e.key === 'Enter') {
            handleLogin(e);
        }
    };
    return (
        <>
            <div className={css.overlay}>
                <form className={css.loginForm} onSubmit={handleLogin}>
                    <div className={css.suImage}>
                        <svg
                            id="Group_4673"
                            data-name="Group 4673"
                            xmlns="http://www.w3.org/2000/svg"
                            width="168.731"
                            height="31.011"
                            viewBox="0 0 168.731 31.011"
                        >
                            <g id="Group_2380" data-name="Group 2380">
                                <g
                                    id="Group_2378"
                                    data-name="Group 2378"
                                    transform="translate(0 2.637)"
                                >
                                    <path
                                        id="Path_1636"
                                        data-name="Path 1636"
                                        d="M7.429,24.44a10.75,10.75,0,0,1-4-.732A11.369,11.369,0,0,1,0,21.514l1.294-1.52a10.693,10.693,0,0,0,2.87,1.914,8.273,8.273,0,0,0,3.321.619,4.615,4.615,0,0,0,2.927-.844,2.7,2.7,0,0,0,1.126-2.195h0a2.927,2.927,0,0,0-.225-1.126,2.308,2.308,0,0,0-.732-.9,5.178,5.178,0,0,0-1.463-.732L6.81,16a18.854,18.854,0,0,1-2.7-.788,6.754,6.754,0,0,1-1.914-1.069,3.883,3.883,0,0,1-1.126-1.463,4.84,4.84,0,0,1-.338-1.97h0a4.446,4.446,0,0,1,.394-1.97A4.615,4.615,0,0,1,2.364,7.162,6.078,6.078,0,0,1,4.277,6.093,7.26,7.26,0,0,1,6.641,5.7a9.962,9.962,0,0,1,3.489.563A10.637,10.637,0,0,1,13,7.95L11.819,9.526a8.892,8.892,0,0,0-2.533-1.52,7.823,7.823,0,0,0-2.645-.45A4.334,4.334,0,0,0,3.827,8.4a2.589,2.589,0,0,0-1.013,2.082h0a3.039,3.039,0,0,0,.225,1.182,2.364,2.364,0,0,0,.732.957,5.516,5.516,0,0,0,1.52.788,18.01,18.01,0,0,0,2.476.675,11.045,11.045,0,0,1,4.5,1.857,4,4,0,0,1,1.463,3.264h0a4.784,4.784,0,0,1-.45,2.139,4.84,4.84,0,0,1-1.294,1.632,5.684,5.684,0,0,1-1.97,1.013,8.161,8.161,0,0,1-2.589.45Z"
                                        transform="translate(0 -5.128)"
                                    />
                                    <path
                                        id="Path_1637"
                                        data-name="Path 1637"
                                        d="M31.525,21.887a5.347,5.347,0,0,0,.507,1.914A4.559,4.559,0,0,0,33.1,25.208a4.615,4.615,0,0,0,1.463.844,4.784,4.784,0,0,0,1.688.281,5.122,5.122,0,0,0,2.42-.507,7.092,7.092,0,0,0,1.8-1.351L41.711,25.6A8.217,8.217,0,0,1,39.4,27.459a6.81,6.81,0,0,1-3.208.675,6.7,6.7,0,0,1-2.589-.507,6.416,6.416,0,0,1-2.139-1.463,6.754,6.754,0,0,1-1.463-2.195A7.429,7.429,0,0,1,29.5,21.1,7.765,7.765,0,0,1,30,18.343a6.866,6.866,0,0,1,1.351-2.252,6.247,6.247,0,0,1,2.026-1.52,6.472,6.472,0,0,1,5.234,0,5.8,5.8,0,0,1,1.97,1.52,6.641,6.641,0,0,1,1.238,2.251,9.061,9.061,0,0,1,.394,2.758v.281a3.827,3.827,0,0,1,0,.394Zm8.667-1.632a6.247,6.247,0,0,0-.394-1.688,4.84,4.84,0,0,0-.844-1.407,3.883,3.883,0,0,0-1.294-1.013,4.052,4.052,0,0,0-1.745-.338,3.883,3.883,0,0,0-1.632.338,4.109,4.109,0,0,0-1.351.957,5.234,5.234,0,0,0-.9,1.407,5.741,5.741,0,0,0-.507,1.8Z"
                                        transform="translate(-12.896 -8.766)"
                                    />
                                    <path
                                        id="Path_1638"
                                        data-name="Path 1638"
                                        d="M61.463,28.2a6.7,6.7,0,0,1-1.857-.281,4.84,4.84,0,0,1-1.632-.788,4.109,4.109,0,0,1-1.126-1.294,3.715,3.715,0,0,1-.45-1.8h0a4.165,4.165,0,0,1,.394-1.914,3.715,3.715,0,0,1,1.182-1.351,5.684,5.684,0,0,1,1.8-.844,8.836,8.836,0,0,1,2.308-.281,14.071,14.071,0,0,1,2.251.169l1.857.394v-.45a3.377,3.377,0,0,0-1.013-2.7,4.277,4.277,0,0,0-2.927-.9,8.386,8.386,0,0,0-2.139.281,11.256,11.256,0,0,0-1.914.675l-.619-1.632a14.127,14.127,0,0,1,2.251-.844,9.849,9.849,0,0,1,2.645-.338,5.879,5.879,0,0,1,4.334,1.463,5.347,5.347,0,0,1,1.407,3.94V27.92H66.3V25.95a6.416,6.416,0,0,1-1.857,1.576A5.8,5.8,0,0,1,61.463,28.2Zm.394-1.632a5.628,5.628,0,0,0,1.745-.281,4.5,4.5,0,0,0,1.407-.732,3.546,3.546,0,0,0,.957-1.126,3.039,3.039,0,0,0,.338-1.463V21.729l-1.688-.394a11.931,11.931,0,0,0-2.195-.169,4.9,4.9,0,0,0-2.87.732,2.308,2.308,0,0,0-1.013,1.97h0a2.308,2.308,0,0,0,.281,1.126,2.476,2.476,0,0,0,.732.844,3.546,3.546,0,0,0,1.069.507A4.446,4.446,0,0,0,61.857,26.569Z"
                                        transform="translate(-24.656 -8.889)"
                                    />
                                    <path
                                        id="Path_1639"
                                        data-name="Path 1639"
                                        d="M85,14.478h2.026v3.489a7.148,7.148,0,0,1,.9-1.52,6.079,6.079,0,0,1,1.238-1.238,5.29,5.29,0,0,1,1.52-.788,5.459,5.459,0,0,1,1.8-.225v2.139h-.169a5.516,5.516,0,0,0-2.082.394,4.671,4.671,0,0,0-1.688,1.182,5.515,5.515,0,0,0-1.126,1.914,7.823,7.823,0,0,0-.394,2.645v5.347H85Z"
                                        transform="translate(-37.161 -8.842)"
                                    />
                                    <path
                                        id="Path_1640"
                                        data-name="Path 1640"
                                        d="M149.7,4.8h2.026v7.879a6.3,6.3,0,0,1,1.745-1.857,4.84,4.84,0,0,1,2.814-.788,5.684,5.684,0,0,1,2.195.394,4.5,4.5,0,0,1,1.632,1.126,4.84,4.84,0,0,1,1.013,1.688,6.472,6.472,0,0,1,.338,2.195v8.33h-2.026V15.944a4.277,4.277,0,0,0-.957-2.927,3.489,3.489,0,0,0-2.758-1.069,4.221,4.221,0,0,0-1.576.281,3.715,3.715,0,0,0-1.294.844,3.827,3.827,0,0,0-.844,1.351,4.728,4.728,0,0,0-.281,1.688v7.654H149.7Z"
                                        transform="translate(-65.447 -4.736)"
                                    />
                                    <path
                                        id="Path_1641"
                                        data-name="Path 1641"
                                        d="M185.841,24.66a8.892,8.892,0,0,1-3.1-.507,6.472,6.472,0,0,1-2.364-1.52,6.754,6.754,0,0,1-1.52-2.476,9.793,9.793,0,0,1-.563-3.377V6.2h2.026V16.668a6.463,6.463,0,0,0,1.463,4.559A5.29,5.29,0,0,0,185.9,22.8a5.347,5.347,0,0,0,4-1.52,6.253,6.253,0,0,0,1.463-4.5V6.2h2.026V16.612a10.3,10.3,0,0,1-.563,3.489,6.81,6.81,0,0,1-1.52,2.533,6.36,6.36,0,0,1-2.364,1.52A9,9,0,0,1,185.841,24.66Z"
                                        transform="translate(-77.95 -5.348)"
                                    />
                                    <path
                                        id="Path_1642"
                                        data-name="Path 1642"
                                        d="M213.1,14.436h2.026v2.308a6.3,6.3,0,0,1,1.745-1.857,4.84,4.84,0,0,1,2.814-.788,5.685,5.685,0,0,1,2.195.394,4.5,4.5,0,0,1,1.632,1.126,4.84,4.84,0,0,1,1.013,1.688,6.473,6.473,0,0,1,.338,2.195v8.33h-2.026V20.007a4.277,4.277,0,0,0-.957-2.927,3.49,3.49,0,0,0-2.758-1.069,4.221,4.221,0,0,0-1.576.281,3.715,3.715,0,0,0-1.295.844,3.827,3.827,0,0,0-.844,1.351,4.728,4.728,0,0,0-.281,1.688V27.83H213.1Z"
                                        transform="translate(-93.165 -8.8)"
                                    />
                                    <path
                                        id="Path_1643"
                                        data-name="Path 1643"
                                        d="M241.6,5.5h2.308V7.751H241.6Zm.113,5.122h2.026V24.073h-2.026Z"
                                        transform="translate(-105.625 -5.042)"
                                    />
                                    <path
                                        id="Path_1644"
                                        data-name="Path 1644"
                                        d="M253.557,12.067H251.7V10.322h1.857V9.14a4.535,4.535,0,0,1,1.182-3.433,3.883,3.883,0,0,1,2.87-1.013h1.182l1.013.281V6.72l-1.013-.225-.957-.113q-2.307,0-2.308,2.87v1.069H259.8V12.01h-4.221V23.717h-2.026Z"
                                        transform="translate(-110.04 -4.686)"
                                    />
                                    <path
                                        id="Path_1645"
                                        data-name="Path 1645"
                                        d="M271.633,32.316a6.248,6.248,0,0,1-1.52-.169l-1.351-.507.675-1.576.957.394,1.126.113a2.251,2.251,0,0,0,1.52-.563,5.46,5.46,0,0,0,1.238-1.97L268.2,14.7h2.195l4.9,11.2,4.334-11.2h2.139l-5.628,13.845a7.373,7.373,0,0,1-1.914,2.927A3.94,3.94,0,0,1,271.633,32.316Z"
                                        transform="translate(-117.254 -9.064)"
                                    />
                                </g>
                                <g
                                    id="Group_2379"
                                    data-name="Group 2379"
                                    transform="translate(51.497)"
                                >
                                    <path
                                        id="Path_1646"
                                        data-name="Path 1646"
                                        d="M95.89,46.138,91.5,41.185,103.6,34.6l.281.338Z"
                                        transform="translate(-91.5 -15.127)"
                                        fill="#f48b00"
                                    />
                                    <rect
                                        id="Rectangle_2433"
                                        data-name="Rectangle 2433"
                                        width="5.178"
                                        height="0.782"
                                        rx="0.391"
                                        transform="translate(13.507 9.286)"
                                    />
                                    <rect
                                        id="Rectangle_2434"
                                        data-name="Rectangle 2434"
                                        width="9.962"
                                        height="0.782"
                                        rx="0.391"
                                        transform="translate(13.507 12.157)"
                                    />
                                    <rect
                                        id="Rectangle_2435"
                                        data-name="Rectangle 2435"
                                        width="8.611"
                                        height="0.782"
                                        rx="0.391"
                                        transform="translate(13.451 14.971)"
                                    />
                                    <path
                                        id="Path_1647"
                                        data-name="Path 1647"
                                        d="M114.472,0a12.494,12.494,0,1,0,11.369,17.616h-5.065a8.161,8.161,0,1,1,1.463-7.542h4.5A12.494,12.494,0,0,0,114.472,0Z"
                                        transform="translate(-96.068 0)"
                                        fill="#f48b00"
                                    />
                                </g>
                            </g>
                            <path
                                id="Path_1648"
                                data-name="Path 1648"
                                d="M293.907,8.7a2.251,2.251,0,0,1-.9-.169A2.487,2.487,0,0,1,291.768,7.3a2.251,2.251,0,0,1-.169-.9h0a2.251,2.251,0,0,1,.169-.9,2.336,2.336,0,0,1,4.277,0,2.251,2.251,0,0,1,.169.9h0a2.251,2.251,0,0,1-.169.9,2.308,2.308,0,0,1-1.238,1.238A2.251,2.251,0,0,1,293.907,8.7Zm0-.225a2.026,2.026,0,0,0,.844-.169,2.138,2.138,0,0,0,.675-.45,2.082,2.082,0,0,0,.619-1.463h0a2.126,2.126,0,0,0-2.082-2.082,2.026,2.026,0,0,0-.844.169,2.139,2.139,0,0,0-.675.45,2.082,2.082,0,0,0-.619,1.463h0a2.126,2.126,0,0,0,2.082,2.082Zm-.9-3.377h1.463l.281.169.169.225a.619.619,0,0,1,.056.281h0a.619.619,0,0,1-.169.45l-.45.225.732.957h-.45l-.675-.9h-.619v.9h-.338Zm1.013,1.182.394-.113a.338.338,0,0,0,.169-.338h0a.338.338,0,0,0-.169-.281l-.394-.113h-.675v.844Z"
                                transform="translate(-127.484 -1.781)"
                            />
                        </svg>
                    </div>
                    <div className={css.formInputs}>
                        <div className={css.formInput_1}>
                            <div className={css.formLabel}>Email</div>
                            <FormControl classes={{ root: css.customFormInput }} size="small">
                                <OutlinedInput
                                    name="email"
                                    placeholder="e.g name@email.com"
                                    className={css.lengthInput}
                                    value={loginInfo.email}
                                    onChange={handleChange('email')}
                                    onKeyPress={checkEnterPressed}
                                    classes={{
                                        root: css.customTextField,
                                        input: css.inputSize
                                    }}
                                    startAdornment={
                                        <InputAdornment position="start">
                                            <PersonIcon className={css.iconInput} />
                                        </InputAdornment>
                                    }
                                />
                            </FormControl>
                        </div>
                        <div className={css.formInput_1}>
                            <div className={css.formLabel}>Password</div>
                            <FormControl classes={{ root: css.customFormInput }} size="small">
                                <OutlinedInput
                                    name="password"
                                    placeholder="Enter you password here..."
                                    type="password"
                                    className={css.lengthInput}
                                    value={loginInfo.password}
                                    onChange={handleChange('password')}
                                    onKeyPress={checkEnterPressed}
                                    classes={{
                                        root: css.customTextField,
                                        input: css.inputSize
                                    }}
                                    startAdornment={
                                        <InputAdornment position="start">
                                            <LockIcon className={css.iconInput} />
                                        </InputAdornment>
                                    }
                                />
                            </FormControl>
                        </div>
                    </div>
                    <div className={css.loginButtonDiv}>
                        <Button
                            disabled={!loginInfo.email || !loginInfo.password}
                            onClick={handleLogin}
                            type="submit"
                            className={css.loginButton}
                            variant="contained"
                        >
                            Login to your dashboard
                        </Button>
                        {/* <Button
                            variant="contained"
                            component={Link}
                            to="/app/dashboard"
                            size="large"
                            className={css.loginButton}
                        >
                            Login to your dashboard
                        </Button> */}
                        {loginData.error.message && (
                            <div className={css.ErrorMessage}>{loginData.error.message}</div>
                        )}
                    </div>
                </form>
            </div>
        </>
    );
}
